import React from "react";
import { useBranding, logoUrl } from "@/hooks/useBranding";

// Renders the client / partner logos side by side on clean white chips so they
// stay legible on dark brand surfaces. Returns null if none uploaded.
// White background is forced inline so the dark-theme `.bg-white` override can't
// darken the chip (client logos are usually dark-inked and need a white backdrop).
export function BrandLogos({ size = "sm", className = "" }) {
  const { branding } = useBranding();
  if (!branding.client && !branding.partner) return null;

  const lg = size === "lg";
  const md = size === "md";
  const xl = size === "xl";
  const chip = `rounded-xl flex items-center justify-center shadow-sm ring-1 ring-black/5 ${xl ? "px-5 py-3" : lg ? "px-5 py-3.5" : md ? "px-4 py-2.5" : "px-3 py-2"}`;
  const imgCls = `${xl ? "h-20 max-w-[280px]" : lg ? "h-14 max-w-[200px]" : md ? "h-12 max-w-[170px]" : "h-9 max-w-[130px]"} w-auto object-contain`;
  const white = { backgroundColor: "#ffffff" };

  return (
    <div className={`flex items-center ${lg ? "gap-4" : md ? "gap-3" : "gap-2.5"} ${className}`} data-testid="brand-logos">
      {branding.client && (
        <div className={chip} style={white}>
          <img src={logoUrl("client", branding.version)} alt="Client logo" className={imgCls} data-testid="brand-logo-client" />
        </div>
      )}
      {branding.partner && (
        <div className={chip} style={white}>
          <img src={logoUrl("partner", branding.version)} alt="Partner logo" className={imgCls} data-testid="brand-logo-partner" />
        </div>
      )}
    </div>
  );
}

export default BrandLogos;
